import { MissingMerkleProvider, MissingSignerError, MissingProviderError, MissingSoundAPI } from '../errors.mjs';
import { getLazyOption } from '../utils/helpers.mjs';

function SoundClientInstance({
  client,
  account,
  merkleProvider,
  onUnhandledError = console.error,
  soundAPI
}) {
  const IdempotentCache = {};
  const IdempotentCachePromises = {};
  function idempotentCachedCall(key, cb) {
    if (key in IdempotentCache)
      return IdempotentCache[key];
    return IdempotentCachePromises[key] || (IdempotentCachePromises[key] = cb().then((value) => {
      IdempotentCache[key] = value;
      return value;
    }).finally(() => {
      delete IdempotentCachePromises[key];
    }));
  }
  const instance = {
    client: client || null,
    wallet: account || null,
    merkleProvider: merkleProvider || null,
    onUnhandledError,
    soundAPI: soundAPI || null,
    idempotentCachedCall
  };
  function expectMerkleProvider() {
    if (instance.merkleProvider)
      return instance.merkleProvider;
    throw new MissingMerkleProvider();
  }
  async function getNetworkChainId() {
    const client2 = await expectClient();
    return client2.chain;
  }
  async function expectWallet() {
    if (instance.wallet) {
      const wallet = await getLazyOption(instance.wallet);
      if (wallet.account) {
        return {
          userAddress: wallet.account.address,
          wallet
        };
      }
    }
    throw new MissingSignerError();
  }
  async function expectClient() {
    if (instance.client) {
      return getLazyOption(instance.client);
    }
    throw new MissingProviderError();
  }
  function expectSoundAPI() {
    const soundAPI2 = instance.soundAPI;
    if (!soundAPI2)
      throw new MissingSoundAPI();
    return soundAPI2;
  }
  return {
    instance,
    expectMerkleProvider,
    expectWallet,
    expectClient,
    expectSoundAPI,
    getNetworkChainId
  };
}

export { SoundClientInstance };
